import { BaseConfig } from '@shared/base-config';

export const Config = {
  ...BaseConfig,
  hasSendResizeTemplatePage: process.env['VUE_APP_HAS_SEND_RESIZE_TEMPLATE_PAGE'] === 'true'
};
